if (!window.__cartTaxValidationInitialized) {
  window.__cartTaxValidationInitialized = true;

  const rfcRegex = /^[A-Z&Ñ]{3,4}\d{6}[A-Z0-9]{3}$/;
  const curpRegex = /^[A-Z][AEIOUX][A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM][A-Z]{2}[B-DF-HJ-NP-TV-Z]{3}[A-Z0-9]\d$/;

  function getDrawer() {
    return document.querySelector('#Cart-Drawer, .cart-drawer, cart-drawer');
  }

  function getCheckoutButton() {
    const drawer = getDrawer();
    return drawer ? drawer.querySelector('button[name="checkout"]') : null;
  }

  function getCheckoutForm() {
    const checkoutButton = getCheckoutButton();
    return checkoutButton ? checkoutButton.closest('form') : null;
  }

  function getRfcField() {
    return document.getElementById('cart-rfc');
  }

  function getCurpField() {
    return document.getElementById('cart-curp');
  }

  function getTaxErrorBox() {
    return document.getElementById('cart-tax-id-error');
  }

  function getTermsCheckbox() {
    const drawer = getDrawer();
    return drawer ? drawer.querySelector('#CartTerms-Drawer') : document.getElementById('CartTerms-Drawer');
  }

  function getTermsErrorBox() {
    return document.getElementById('CartTermsError-Drawer');
  }

  function showError(errorBox, message) {
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function clearError(errorBox) {
    if (!errorBox) return;
    errorBox.textContent = '';
    errorBox.hidden = true;
  }

  function clearInputError(field, placeholder) {
    if (!field) return;
    field.classList.remove('input-error');
    field.placeholder = placeholder;
  }

  function setInputError(field, message, keepValue) {
    if (!field) return;
    field.classList.add('input-error');
    if (!keepValue) {
      field.value = '';
      field.placeholder = message;
    }
  }

  function normalizeTaxFields() {
    const rfcField = getRfcField();
    const curpField = getCurpField();

    if (rfcField) {
      rfcField.value = rfcField.value.trim().toUpperCase().replace(/[^A-ZÑ&0-9]/g, '').slice(0, 13);
    }

    if (curpField) {
      curpField.value = curpField.value.trim().toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18);
    }
  }

  function validateTaxFields() {
    const rfcField = getRfcField();
    const curpField = getCurpField();
    const taxErrorBox = getTaxErrorBox();

    if (!rfcField || !curpField ) {
      return true;
    }

    normalizeTaxFields();

    const rfc = rfcField.value;
    const curp = curpField.value;

    clearInputError(rfcField, 'RFC');
    clearInputError(curpField, 'CURP');
    clearError(taxErrorBox);

    if (!rfc && !curp) {
      setInputError(rfcField, '', true);
      setInputError(curpField, '', true);
      showError(taxErrorBox, 'Debes ingresar al menos un dato: RFC o CURP.');
      return false;
    }

    if (rfc) {
      if (!(rfc.length === 12 || rfc.length === 13)) {
        setInputError(rfcField, 'RFC de 12 o 13 caracteres', false);
        showError(taxErrorBox, 'El RFC debe tener 12 o 13 caracteres.');
        return false;
      }

      if (!rfcRegex.test(rfc)) {
        setInputError(rfcField, 'Formato de RFC inválido', false);
        showError(taxErrorBox, 'El RFC ingresado no tiene un formato válido.');
        return false;
      }
    }

    if (curp) {
      if (curp.length !== 18) {
        setInputError(curpField, 'CURP de 18 caracteres', false);
        showError(taxErrorBox, 'La CURP debe tener 18 caracteres.');
        return false;
      }

      if (!curpRegex.test(curp)) {
        setInputError(curpField, 'Formato de CURP inválido', false);
        showError(taxErrorBox, 'La CURP ingresada no tiene un formato válido.');
        return false;
      }
    }

    clearError(taxErrorBox);
    return true;
  }

  function validateTerms() {
    const termsCheckbox = getTermsCheckbox();
    const termsErrorBox = getTermsErrorBox();

    clearError(termsErrorBox);

    if (!termsCheckbox) {
      return true;
    }

    if (!termsCheckbox.checked) {
      showError(termsErrorBox, 'Debes aceptar los términos y condiciones.');
      return false;
    }

    return true;
  }

  function ensureHiddenInput(form, name, value) {
    if (!form) return;

    let input = form.querySelector('input[type="hidden"][name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
  }

  function syncTaxFieldsToCheckoutForm() {
    const checkoutForm = getCheckoutForm();
    const rfcField = getRfcField();
    const curpField = getCurpField();

    if (!checkoutForm) return;

    ensureHiddenInput(checkoutForm, 'attributes[RFC]', rfcField ? rfcField.value.trim().toUpperCase() : '');
    ensureHiddenInput(checkoutForm, 'attributes[CURP]', curpField ? curpField.value.trim().toUpperCase() : '');
  }

  function validateAllAndSync() {
    const taxOk = validateTaxFields();
    const termsOk = validateTerms();

    if (taxOk) {
      syncTaxFieldsToCheckoutForm();
    }

    return taxOk && termsOk;
  }

  document.addEventListener('input', function (event) {
    const rfcField = getRfcField();
    const curpField = getCurpField();
    const taxErrorBox = getTaxErrorBox();

    if (rfcField && event.target === rfcField) {
      clearInputError(rfcField, 'RFC');
      clearError(taxErrorBox);
    }

    if (curpField && event.target === curpField) {
      clearInputError(curpField, 'CURP');
      clearError(taxErrorBox);
    }
  });

  document.addEventListener('blur', function (event) {
    const rfcField = getRfcField();
    const curpField = getCurpField();

    if ((rfcField && event.target === rfcField) || (curpField && event.target === curpField)) {
      normalizeTaxFields();
      syncTaxFieldsToCheckoutForm();
    }
  }, true);

  document.addEventListener('change', function (event) {
    const termsCheckbox = getTermsCheckbox();
    const termsErrorBox = getTermsErrorBox();
    const rfcField = getRfcField();
    const curpField = getCurpField();

    if (termsCheckbox && event.target === termsCheckbox) {
      clearError(termsErrorBox);
    }

    if ((rfcField && event.target === rfcField) || (curpField && event.target === curpField)) {
      syncTaxFieldsToCheckoutForm();
    }
  });

  document.addEventListener('click', function (event) {
    const drawer = getDrawer();
    if (!drawer) return;

    const clickedButton = event.target.closest('button[name="checkout"]');
    if (!clickedButton) return;
    if (!drawer.contains(clickedButton)) return;

    if (!validateAllAndSync()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  document.addEventListener('submit', function (event) {
    const drawer = getDrawer();
    const checkoutForm = getCheckoutForm();

    if (!drawer || !checkoutForm) return;
    if (event.target !== checkoutForm) return;
    if (!drawer.contains(checkoutForm)) return;

    if (!validateAllAndSync()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);
}
